import { vatDescription } from '../helpers/vatDescription';

import axios from 'axios';
import * as config from '../config';
import IField from 'src/interfaces/IFormField';

export const companyChangeLock = (fieldName: string, value: any, values: any) => {
    if (!values) {
        return false;
    }

    if (!values.CompanyVatValidationDate) {
        return false;
    }

    const vatNumber = values.CompanyVatNumber;
    const addressCountry = values.AddressCountry;
    const companyName = values.Company;

    if (!vatNumber || vatNumber.trim() === '') {
        return false;
    }

    if (!companyName || companyName.trim() === '') {
        return false;
    }

    if (!addressCountry || addressCountry.trim() === '') {
        return false;
    }

    return true;
};

export default [
    {
        fieldName: 'Firstname',
        label: 'First name',
        type: 'text',
        isRequired: true,
    },
    {
        fieldName: 'Lastname',
        label: 'Last name',
        type: 'text',
        isRequired: true,
    },
    {
        fieldName: 'Email',
        label: 'E-mail',
        type: 'email',
        disabled:  true, 
        isRequired: true,
    },
    {
        fieldName: 'Phone',
        label: 'Phone',
        type: 'text',
        isRequired: true,
    },
    {
        fieldName: 'Address',
        type: 'address',
        isRequired: true,
        // fields: addressTwoLinesFields
    },
    {
        fieldName: 'AnotherDeliveryAddress',
        type: 'hidden',
        label: 'Different delivery address',
        fields: [
            {
                fieldName: 'DeliveryAddress',
                type: 'address',
                isRequired: true
            }
        ]
    },
    {
        fieldName: 'CompanyInformation',
        type: 'hidden',
        label: 'Company information',
        disabled: companyChangeLock,
        fields: [
            {
                fieldName: 'Company',
                label: 'Company name',
                type: 'text',
                disabled: companyChangeLock
            },
            {
                fieldName: 'CompanyRegistrationNumber',
                label: 'Company reg. number',
                type: 'text'
            },
            {
                fieldName: 'CompanyVatNumber',
                label: `Company ${vatDescription()} number`,
                type: 'text',
                disabled: companyChangeLock,
                validationMessage: 'Invalid VAT number',
                validation: async (vatNumber: string, { CompanyVatValidationDate, CompanyInformation, AddressCountry, Email }: any, field: IField) => {
                    if (!CompanyInformation) {
                        console.log('Company information are not used. No validation needed.');
                        return true;
                    }

                    if (vatNumber.trim() === '') {
                        return true; // empty VAT number is allowed
                    }

                    // validace DIČ
                    const { data } = await axios({
                        method: 'POST',
                        url: config.url + '/orders/vat-validator',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        data: {
                            email: Email,
                            country: AddressCountry,
                            vatNumber,
                        }
                    });

                    if (data.validationRequired === false) {
                        console.log('VAT number validation not required');
                        return true;
                    }

                    field.validationMessage = `${vatDescription()} ${data.message}`;
                    console.log('VAT number validation result:', data);
                    return data.valid;
                }
            }
        ]
    },
    {
        fieldName: 'Newsletter',
        type: 'bool',
        label: 'I want to subscribe to your newsletter'
    }
];


// WEBPACK FOOTER //
// ./src/formFields/userData.tsx